import { deliHistory } from '@global';
import { MultiPartyCompanyMappingDetail } from '.';
export function createReturnParam(prefix = '/company-mapping/search') {
  const location = deliHistory.location;
  return location.search
    ? `&${new URLSearchParams({
        returnTo: `${prefix}${location.search}`,
      })}`
    : '';
}
export function isSinglePartyDeal(companymapping: MultiPartyCompanyMappingDetail) {
  if (!companymapping.company1 || !companymapping.company2) {
    return false;
  }

  let isSingleParty = companymapping.company2.length === 1;

  // if (isSingleParty && companymapping.contents && companymapping.contents.length >= 1) {
  //   isSingleParty = companymapping.contents.length === 1;
  // }

  if (isSingleParty && companymapping.company2 && companymapping.company2.length >= 1) {
    isSingleParty = companymapping.company2.length === 1;
  }

  return isSingleParty;
}
